import axios from "axios";


async function fileToBlob(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // result is ArrayBuffer, convert to Blob explicitly if needed
      const arrayBuffer = reader.result;
      const blob = new Blob([arrayBuffer], { type: file.type });
      resolve(blob);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

async function compressImages(files, quality = 75) {
  try {
     const formData = new FormData();

    // Convert each file to binary blob first, then append
    for (const file of files) {
        
      const binaryBlob = await fileToBlob(file.file);
      formData.append("images", binaryBlob, file.name);
    }

    formData.append("quality", quality);

    const response = await axios.post(
      "https://api.iluvimg.com/api/Compression/compress",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      }
    );

    // Get Task ID from header
    const taskId = response.headers["x-task-id"];
    console.log("Task ID:", taskId);

    // Download file    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `compressed_file.${response.data.type.split('/')[1]}`);
    document.body.appendChild(link);
    link.click();
    link.remove();

  } catch (error) {
    console.error("Compression failed:", error);
  }
}

export default compressImages